/**
 * Do not edit directly
 * Generated on Thu, 23 May 2024 10:22:55 GMT
 */

export const TokenSetOrder0 = "global";
export const Primary10 = "#001833";
export const Primary20 = "#00397A";
export const Primary30 = "#155297";
export const Primary40 = "#2E6BB0";
export const Primary50 = "#4582C7";
export const Primary60 = "#619EE3";
export const Primary70 = "#7CB9FE";
export const Primary80 = "#A8D1FF";
export const Primary90 = "#D4E8FF";
export const Primary95 = "#E9F3FF";
export const Primary99 = "#FBFDFF";
export const Primary45Base = "#3A76BA";
export const Accent0110 = "#192300";
export const Accent0120 = "#2C3D00";
export const Accent0130 = "#415900";
export const Accent0140 = "#577210";
export const Accent0150 = "#6F8A28";
export const Accent0170 = "#A4BF5D";
export const Accent0180 = "#C0DB79";
export const Accent0190 = "#DCF795";
export const Accent0195 = "#ECFFBA";
export const Accent0199 = "#FBFFF1";
export const Accent0160Base = "#88A341";
export const Accent0210 = "#00272B";
export const Accent0220 = "#00454C";
export const Accent0230 = "#03646E";
export const Accent0240 = "#1B7C86";
export const Accent0250 = "#34959F";
export const Accent0270 = "#69CAD4";
export const Accent0280 = "#85E6F0";
export const Accent0290 = "#B6F8FF";
export const Accent0295 = "#DCFCFF";
export const Accent0299 = "#F7FEFF";
export const Accent0260Base = "#4daeb8";
export const Accent0310 = "#350A44";
export const Accent0320 = "#421751";
export const Accent0330 = "#552A64";
export const Accent0340 = "#673C76";
export const Accent0350 = "#7F548E";
export const Accent0360 = "#A57AB4";
export const Accent0370 = "#C499D3";
export const Accent0380 = "#E1B6F0";
export const Accent0390 = "#F5D9FF";
export const Accent0395 = "#FAECFF";
export const Accent0399 = "#FEFAFF";
export const Accent0355Base = "#90659f";
export const Neutral10 = "#161E22";
export const Neutral20 = "#2B3337";
export const Neutral30 = "#41494D";
export const Neutral40 = "#596165";
export const Neutral50 = "#71797D";
export const Neutral60 = "#8B9397";
export const Neutral70 = "#A6AEB2";
export const Neutral80 = "#C1C9CD";
export const Neutral90 = "#DDE5E9";
export const Neutral95 = "#EBF3F7";
export const Neutral99 = "#FAFDFF";
export const Positive10 = "#062C00";
export const Positive20 = "#0A4D00";
export const Positive30 = "#1C6711";
export const Positive40 = "#337E28";
export const Positive60 = "#66B15B";
export const Positive70 = "#81CC76";
export const Positive80 = "#9CE791";
export const Positive90 = "#BDFFB3";
export const Positive95 = "#DEFFD9";
export const Positive99 = "#F9FFF8";
export const Positive50Base = "#4B9640";
export const Cautionary10 = "#291A00";
export const Cautionary20 = "#472E00";
export const Cautionary30 = "#684300";
export const Cautionary40 = "#8B5A00";
export const Cautionary50 = "#AA7109";
export const Cautionary60 = "#C58C24";
export const Cautionary70 = "#DFA63E";
export const Cautionary90 = "#FFE0A7";
export const Cautionary95 = "#FFEFD2";
export const Cautionary99 = "#FFFCF7";
export const Cautionary80Base = "#FAC159";
export const Negative10 = "#590009";
export const Negative20 = "#9C0010";
export const Negative30 = "#BA1324";
export const Negative40 = "#D12A3B";
export const Negative50 = "#FF8692";
export const Negative60 = "#FF6070";
export const Negative70 = "#FF8692";
export const Negative80 = "#FFADB5";
export const Negative90 = "#FFD6DA";
export const Negative95 = "#FFEBED";
export const Negative99 = "#FFFBFE";
export const Negative45Base = "#dc3546";
export const DecorativeFreshAubergine = "#751b7c";
export const DecorativeKobi = "#dba7c9";
export const DecorativeRainForest = "#2d6b67";
export const DecorativeVermillion = "#ba573c";
export const DecorativePacificBlue = "#b2e0f7";
export const DecorativeDeepChampagne = "#f8d0a0";
export const DecorativeWasabi = "#d1eb81";
export const DecorativeRazzmatazz = "#e6006b";
export const DecorativeHoney = "#e9b049";
export const DecorativeUmber = "#645146";
export const DecorativeTurbo = "#FFFF00";
export const LayoutSideMenu = "320px";
export const AnimationTransitionNormal = "0.3s";
export const AnimationTransitionFast = "0.2s";
export const AnimationTransitionFastest = "0.1s";
export const AnimationTransitionSlow = "0.4s";
export const AnimationTransitionSlowest = "0.5s";
export const BorderRadius = "3px";
export const Widths13 = "33%";
export const Widths23 = "66%";
export const Widths12 = "50%";
export const Widths14 = "25%";
export const Widths34 = "75%";
export const Widths15 = "20%";
export const Widths25 = "40%";
export const Widths35 = "60%";
export const Widths45 = "80%";
export const WidthsSidePanel = "320px";
export const H1FontFamily = "Roboto";
export const H1FontWeight = 700;
export const H1LineHeight = "2.1875rem";
export const H1FontSize = "1.8125rem";
export const H1LetterSpacing = "-0.01em";
export const H2FontFamily = "Roboto";
export const H2FontWeight = 700;
export const H2LineHeight = "2.0625rem";
export const H2FontSize = "1.625rem";
export const H2LetterSpacing = "-0.005em";
export const H3FontFamily = "Roboto";
export const H3FontWeight = 700;
export const H3LineHeight = "2rem";
export const H3FontSize = "1.4375rem";
export const H4FontFamily = "Roboto";
export const H4FontWeight = 700;
export const H4LineHeight = "1.75rem";
export const H4FontSize = "1.25rem";
export const H5FontFamily = "Roboto";
export const H5FontWeight = 700;
export const H5LineHeight = "1.56rem";
export const H5FontSize = "1.125rem";
export const H5ParagraphSpacing = "2rem";
export const H6FontFamily = "Roboto";
export const H6FontWeight = 700;
export const H6LineHeight = "1.375rem";
export const H6FontSize = "1rem";
export const H6ParagraphSpacing = "2rem";
export const PFontFamily = "Roboto";
export const PFontWeight = 400;
export const PLineHeight = "1.25rem";
export const PFontSize = "0.875rem";
export const PParagraphSpacing = "1.25rem";
export const PSmallFontFamily = "Roboto";
export const PSmallFontWeight = 400;
export const PSmallLineHeight = "1.25rem";
export const PSmallFontSize = "0.75rem";
export const PSmallParagraphSpacing = "1.25rem";
export const BorderWidthNormal = "2px";
export const BorderWidthThin = "1px";
export const Opacity50 = 0.5;
export const Opacity10 = 0.1;
export const BreakpointsSmall = "576px";
export const BreakpointsMedium = "768px";
export const BreakpointsLarge = "992px";
export const BreakpointsXLarge = "1200px";
export const Breakpoints2xLarge = "1400px";
export const BreakpointValuesBreakpointValueSmall = "576px";
export const BreakpointValuesBreakpointValueMedium = "768px";
export const BreakpointValuesBreakpointValueLarge = "992px";
export const BreakpointValuesBreakpointValueXLarge = "1200px";
export const BreakpointValuesBreakpointValue2xLarge = "1400px";
export const SpacingXs = "0.25rem";
export const SpacingS = "0.5rem";
export const SpacingM = "1rem";
export const SpacingL = "1.5rem";
export const SpacingXl = "2rem";
export const Spacing2xl = "3rem";
export const Shadows20 = [{"color":"#161E220d","type":"dropShadow","x":0,"y":0,"blur":1,"spread":0},{"color":"#161E221a","type":"dropShadow","x":0,"y":1,"blur":3,"spread":0}];
export const Shadows40 = [{"color":"#161E220d","type":"dropShadow","x":0,"y":0,"blur":1,"spread":0},{"color":"#161E221a","type":"dropShadow","x":0,"y":2,"blur":4,"spread":0}];
export const Shadows60 = [{"color":"#161E220d","type":"dropShadow","x":0,"y":0,"blur":1,"spread":0},{"color":"#161E221a","type":"dropShadow","x":0,"y":4,"blur":8,"spread":0}];
export const Shadows80 = [{"color":"#161E220d","type":"dropShadow","x":0,"y":0,"blur":1,"spread":0},{"color":"#161E221a","type":"dropShadow","x":0,"y":8,"blur":16,"spread":0}];
export const Shadows100 = [{"color":"#161E220d","type":"dropShadow","x":0,"y":0,"blur":1,"spread":0},{"color":"#161E221a","type":"dropShadow","x":0,"y":16,"blur":24,"spread":0}];
export const ShadowsDark20 = [{"color":"#000000","type":"dropShadow","x":0,"y":0,"blur":1,"spread":0},{"color":"#000000","type":"dropShadow","x":0,"y":1,"blur":3,"spread":0}];
export const ShadowsDark40 = [{"color":"#000000","type":"dropShadow","x":0,"y":0,"blur":1,"spread":0},{"color":"#000000","type":"dropShadow","x":0,"y":2,"blur":4,"spread":0}];
export const ShadowsDark60 = [{"color":"#000000","type":"dropShadow","x":0,"y":0,"blur":1,"spread":0},{"color":"#000000","type":"dropShadow","x":0,"y":4,"blur":8,"spread":0}];
export const ShadowsDark80 = [{"color":"#000000","type":"dropShadow","x":0,"y":0,"blur":1,"spread":0},{"color":"#000000","type":"dropShadow","x":0,"y":8,"blur":16,"spread":0}];
export const ShadowsDark100 = [{"color":"#000000","type":"dropShadow","x":0,"y":0,"blur":1,"spread":0},{"color":"#000000","type":"dropShadow","x":0,"y":16,"blur":24,"spread":0}];
